

/**
 * Alert used for Web
 * @param {string} text - message to display
 */
export const AppAlert = (text:string) => {
  alert(text)
}